namespace Gordic.Vyp.Lists
{
    @Decorators.gcontent
    export class ProvedenaVypraveniZasilekObsahListPage extends GContentBase<VypListBasePage>
    {
        TridVyp: number;
        ZpusobDorProp: Gordic.Wfl.Interface.WflczpdEnum;
        data: Gordic.Wfl.Interface.GSeznamZasilekDto[];

        onContentReady()
        {
            this.IsObsah = true;
            this.minimalHeightObsahu = 500;
            Gordic.Wfl.AC.WflBaseAC.ClearControl(this);
            Wfl.ListAC.WflZasilkyListBaseAC.InitList(this);
            VypListBasePage.CreateFrankovaniActions(this);  
            ////this.specialActions.push(Wfl.ListAC.WflZasilkyListBaseAC.CreateActionZnovuodeslatZasilky(this, false));
            //Wfl.ListAC.WflZasilkyListBaseAC.CreateActionZnovuodeslatZasilky(this, false);
            //VypListBasePage.CreateActionsPredplneni(this);
            this.specialActions.push(VypListBasePage.CreateActionEditaceDatPredplneni(this, true));               
            this.specialActions.push(VypListBasePage.CreateActionZmenaHodnot(this, true));
            VypListBasePage.CreateActionsPredplneni(this);
            this.specialActions.push(Wfl.ListAC.WflZasilkyListBaseAC.CreateActionUlozitZmenyZasilek(this, true));
            this.specialActions.push(VypListBasePage.CreateActionImportDatEpaPosty(this));

            VypListBasePage.CreateActionsTisk(this);
            this.printActionsSubmenu.push(VypListBasePage.CreateActionTiskVypravenychDokSpis(this))
            this.printActionsSubmenu.push(Gordic.Wfl.ListAC.WflZasilkyListBaseAC.CreateActionTiskObalek(this))
            Gordic.Wfl.ListAC.WflListBaseAC.CompleteMenu(this);
            Lists.VypListBasePage.CreateGridZasilekVyp(this);
            this.SetData();
        }
    
        LoadData()
        {
            if (this.TridVyp)
            {
                var that = this;
                Gin.Globals.ShowWaitLoadData(this);
                this.call<Gordic.Wfl.Interface.GSeznamZasilekDto[]>("LoadDataThis", { TridVyp: this.TridVyp })
                    .done(function (data) {
                        if (data) {
                            that.data = data;
                            debugger;
                            that.SetData();
                        }
                    })
                    .always(function () {
                        that.endOperation();
                    });
            }
        }

        SetData()
        {  
            if (this.data)
            {
                var view = new Gordic.Data.View(this.data, { key: this.IDPrimaryKeyGridu });  //key je dulezity kvuli pripadnemu vyhledavani radku
                this.mainGrid.ggrid("setData", view); 
            }
        }

        ReloadData()
        {
            debugger;
            this.LoadData();
        }
    }
}

